import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { CraftCalculatorStateService } from '../craft-calculator-state.service';
import { CopyTextButtonComponent } from 'src/app/shared/components/copy-text-button/copy-text-button.component';
import { CheckPriceButtonComponent } from 'src/app/shared/components/check-price-button/check-price-button.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ItemImageComponent } from 'src/app/shared/components/item-image/item-image.component';

@Component({
  selector: 'app-craft-calculator-results',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatChipsModule, MatIconModule, CheckPriceButtonComponent, CopyTextButtonComponent, MatTooltipModule, ItemImageComponent],
  templateUrl: './craft-calculator-results.component.html',
  styleUrl: './craft-calculator-results.component.scss',
})
export class CraftCalculatorResultsComponent {
  public selectedCrafts = computed(() => {
    return this.craftCalculatorStateService.craftGroup().selectedCrafts();
  });

  constructor(public craftCalculatorStateService: CraftCalculatorStateService) {}
}
